import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black py-20">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-12 mb-16 pb-16 border-b border-gray-800">
          <div className="lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_blackbird-redesign/artifacts/iuwp2epg_logo-trade-black-svg.svg" 
              alt="Blackbird Trade Group" 
              className="h-10 mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed max-w-sm mb-6">
              Expert trade compliance and advisory services for companies navigating international regulations.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'Trade Compliance', link: '/services/trade-compliance' },
                { label: 'Trade Management', link: '/services/trade-management' },
                { label: 'HTS Classification', link: '/services/hts-classification' },
                { label: 'Compliance Audits', link: '/services/compliance-audits' },
                { label: 'FTZ Advisory', link: '/services/foreign-trade-zone' }
              ].map(item => (
                <li key={item.label}>
                  <Link to={item.link} className="text-gray-400 hover:text-white transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'About Us', link: '/about' },
                { label: 'Resources', link: '/resources' },
                { label: 'Insights', link: '/blog' },
                { label: 'Blackbird AI', link: '/blackbird-ai' },
                { label: 'Contact', link: '/contact' }
              ].map(item => (
                <li key={item.label}>
                  <Link to={item.link} className="text-gray-400 hover:text-white transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-3 text-sm text-gray-400">
              <p>info@blackbirdtradegroup.com</p>
              <p>Miami, FL | Paris, France</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-center text-sm text-gray-500">
          <p>© 2024 Blackbird Trade Group. All rights reserved.</p>
          <div className="flex gap-8 mt-4 lg:mt-0">
            <Link to="/privacy" className="hover:text-gray-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-300 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;